import axios from "axios";
import { parseInt } from "lodash";

export const APP_NAME = "Tafwija";

// Tell the backend which language to localize responses in (validation
// messages, etc). Reads the same key i18next persists the UI language to.
axios.interceptors.request.use((config) => {
  try {
    const lng = localStorage.getItem("tafwija_lang") || "fr";
    config.headers = config.headers || {};
    config.headers["Accept-Language"] = lng;
  } catch (e) {
    /* localStorage unavailable — fall back to backend default */
  }
  return config;
});
// export const URL = "http://localhost";
export const URL = ( window.location.protocol + "//" + window.location.host ) ?? 'https://tafwija.com';
//export const URL = 'http://travel.ultraphenix.com';
// export const URL = 'https://tafwija.com';
const API = URL + "/api";

// Base URL of the Laravel-served partner app (dashboard / login / register).
// It is a SEPARATE server-rendered app, not part of this React SPA, and its
// location differs per environment:
//   - local:      http://localhost/partner   (path prefix, proxied to Laravel:80)
//   - production: https://partner.tafwija.com (subdomain, NO /partner prefix)
// Set REACT_APP_PARTNER_URL per environment; falls back to `${URL}/partner`.
export const PARTNER_URL = process.env.REACT_APP_PARTNER_URL || (URL + "/partner");

export const ROADERS = [
  { id: 1, value: 0, name: "Je ne suis pas motorisé" },
  { id: 2, value: 3, name: "Je suis motorisé, j’ai 3 places libres" },
  { id: 3, value: 2, name: "Je suis motorisé, j’ai 2 places libres" },
  { id: 4, value: 1, name: "Je suis motorisé, j’ai une place libres" },
  { id: 5, value: 0, name: "Je suis motorisé, je n’ai aucune place libre" },
];

export const priceFormat = (price) => {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "MAD",
  }).format(price);
};

/**
 * Return full data like total prices of event and much more ...
 * @param {order} order = order information
 */
export function OrderInfo(order) {
  let info = {
    totalPlaces: 0,
    roader: "",
    totalPrice: 0,
    totalPriceByDiscount: 0,
    totalPricePay: 0,
    totalPriceRest: 0,
  };

  order.prices.forEach((item) => {
    let qt = parseInt(item.qt ?? item.quantities);
    info.totalPrice = info.totalPrice + parseInt(item.price) * qt;
    info.totalPlaces = info.totalPlaces + qt;
  });
  // if the customer has a discount
  info.totalPriceByDiscount =
    info.totalPrice -
    (info.totalPrice / 100) *
      (parseInt(order.coupon_value)
        ? parseInt(order.coupon_value)
        : parseInt(order.customer_discount));

  info.totalPricePay =
    info.totalPriceByDiscount -
    (info.totalPriceByDiscount / 100) * (100 - order.percentage_paid);

  info.totalPriceRest =
    info.totalPriceByDiscount -
    (info.totalPriceByDiscount / 100) * order.percentage_paid;
  if (ROADERS.some((r) => r.id === parseInt(order.roader))) {
    info.roader = ROADERS.find((r) => r.id === parseInt(order.roader)).name;
  }
  return info;
}

/**
 * Event
 * @id = event ID
 */

export async function Settings() {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/settings")
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Frequently Asked Questions
 */
export async function FAQ() {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/faqs")
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Condetion general
 */
export async function CGU() {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/cgus")
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * get Social login link
 */
export async function socialLoginLink(provider) {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/auth/" + provider)
      .then(async (res) => {
        await resolve(res.data);
      })
      .catch(async (err) => {
        await reject(err.response);
      });
  });
}

/**
 * get Social login callback
 */

export async function socialLoginCallback(provider, request = "") {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/auth/" + provider + "/callback" + request)
      .then(async (res) => {
        await localStorage.setItem("auth", JSON.stringify(res.data));
        await resolve(res);
      })
      .catch(async (err) => {
        await reject(err.response);
      });
  });
}

/**
 * Auth
 * Get user from api
 */
export const AuthStorage = JSON.parse(localStorage.getItem("auth")) || {};
export async function Auth() {
  // Read the token fresh from localStorage — the module-level AuthStorage is a
  // snapshot from import time and would be stale after an inline login/register.
  const auth = JSON.parse(localStorage.getItem("auth")) || {};
  return await new Promise((resolve, reject) => {
    if (Object.keys(auth).length) {
      // There is some data

      axios
        .get(API + "/user", {
          headers: {
            Authorization: `Bearer ${auth.access_token}`,
          },
        })
        .then(async (res) => {
          if (res.data.user.status == 1) {
            // Auth user has no active status
            let updateAuthStorage = { ...auth, user: res.data.user };
            localStorage.setItem("auth", JSON.stringify(updateAuthStorage));
            resolve(updateAuthStorage);
          } else {
            reject({ errors: "Your acount is not active" });
          }
        })
        .catch((err) => {
          if (Object.keys(err.response).length) {
            reject(err.response.data);
          }
        });
    } else {
      reject({ errors: "Unauthorized" });
    }
  });
}
/**
 *
 * @param { email , name , phone , country , city , address , code_postal , oldPassword , password , password_confermation } FORM
 */
export async function ChangeUserInfo(FORM, token = null) {
  let AuthStorage = (await JSON.parse(localStorage.getItem("auth"))) || {};
  return await new Promise((resolve, reject) => {
    axios
      .put(API + "/user/update", FORM, {
        headers: {
          Authorization: `Bearer ${token ?? AuthStorage.access_token}`,
        },
      })
      .then(async (res) => {
        let updateAuthStorage = { ...AuthStorage, user: res.data.user };
        await localStorage.setItem("auth", JSON.stringify(updateAuthStorage));
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 *
 * @param { phone } FORM
 */
export async function SignNumber(FORM) {
  const auth = JSON.parse(localStorage.getItem("auth")) || {};
  return await new Promise((resolve, reject) => {
    axios
      .post(API + "/verify/account/phone", FORM, {
        headers: {
          Authorization: `Bearer ${auth.access_token}`,
        },
      })
      .then(async (res) => {
        //let updateAuthStorage = { ...AuthStorage , user : res.data.user };
        //localStorage.setItem( 'auth' , JSON.stringify( updateAuthStorage ) );
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 *
 * @param { verification_code } FORM
 */
export async function ConfermNumber(FORM) {
  const auth = JSON.parse(localStorage.getItem("auth")) || {};
  return await new Promise((resolve, reject) => {
    axios
      .post(API + "/verify/account", FORM, {
        headers: {
          Authorization: `Bearer ${auth.access_token}`,
        },
      })
      .then(async (res) => {
        //let updateAuthStorage = { ...AuthStorage , user : res.data.user };
        //localStorage.setItem( 'auth' , JSON.stringify( updateAuthStorage ) );
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 *
 *
 */
export async function ResendVerefecationEmail() {
  return await new Promise((resolve, reject) => {
    axios
      .post(
        API + "/email/resend",
        {},
        {
          headers: {
            Authorization: `Bearer ${AuthStorage.access_token}`,
          },
        }
      )
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 *
 * @param { token }
 */
export async function ConfermVerefecationEmail(token) {
  return await new Promise((resolve, reject) => {
    axios
      .post(
        API + `/email/verify/${token}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${AuthStorage.access_token}`,
          },
        }
      )
      .then(async (res) => {
        let userrr = { ...AuthStorage.user, email_verified_at: new Date() };
        let updateAuthStorage = { ...AuthStorage, user: userrr };
        localStorage.setItem("auth", JSON.stringify(updateAuthStorage));

        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 *
 * @param { email , name , phone , country , city , address , code_postal , oldPassword , password , password_confermation } FORM
 */
export async function ChangePartnerInfo(FORM, myHeader = {}) {
  return await new Promise((resolve, reject) => {
    const _header = {
      Authorization: `Bearer ${AuthStorage.access_token}`,
    };
    const _headerAssign = Object.assign(_header, myHeader);
    axios
      .post(API + "/partner/update", FORM, {
        headers: _headerAssign,
      })
      .then(async (res) => {
        let updateAuthStorage = { ...AuthStorage, user: res.data.user };
        localStorage.setItem("auth", JSON.stringify(updateAuthStorage));
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function Logout() {
  return await new Promise((resolve, reject) => {
    try {
      localStorage.removeItem("auth");

      // Verify against localStorage itself, NOT the module-level AuthStorage
      // snapshot: that constant is captured once when the bundle parses, so
      // for anyone who signed in during this session it is still populated
      // here and the old check rejected — sending logout down the
      // `window.location.reload()` path instead of redirecting.
      const remaining = JSON.parse(localStorage.getItem("auth") || "{}");
      if (!Object.keys(remaining).length) {
        resolve({});
      } else {
        reject({ message: "You cant clear storage session" });
      }
    } catch (e) {
      reject(e);
    }
  });
}

/**
 * Sign in
 * make login connection and return a token key for authorization
 */
export async function SignIn(FORM) {
  await localStorage.setItem("auth", "{}");
  await localStorage.removeItem("auth");
  return await new Promise((resolve, reject) => {
    axios
      .post(API + "/login", FORM)
      .then(async (res) => {
        //console.log( res.data );
        localStorage.setItem("auth", JSON.stringify(res.data));
        resolve(res);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Sign up
 * registr new user or partner to the system
 */

export async function SignUp(FORM) {
  await localStorage.setItem("auth", "{}");
  await localStorage.removeItem("auth");
  return await new Promise((resolve, reject) => {
    axios
      .post(API + "/signup", FORM)
      .then(async (res) => {
        res.data.user.isVerified = false;
        localStorage.setItem("auth", JSON.stringify(res.data));
        resolve(res);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function ForgotPassword(FORM) {
  return await new Promise((resolve, reject) => {
    axios
      .post(API + "/forgot", FORM)
      .then(async (res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function ResetPassword(FORM) {
  return await new Promise((resolve, reject) => {
    axios
      .post(API + "/reset", FORM)
      .then(async (res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Galleries
 */
export async function Galleries(page = 1) {
  let per_page = 9;
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/galleries?per_page=" + per_page + "&page=" + page)
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Galery
 * @galery_id { id }
 */
export async function Gallery(id) {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/galleries/" + id)
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Blogs
 */
export async function Posts(page = 1) {
  let per_page = 9;
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/blogs?per_page=" + per_page + "&page=" + page)
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Post Blog
 * @article_id { id }
 */
export async function Post(id) {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/blogs/" + id)
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Categories
 */

export async function Categories() {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/categories")
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Cities
 */

export async function Cities() {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/cities")
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Start cities for events
 */

export async function CitiesDepart() {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/cities-depart")
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Search for events
 * @distination = city ID
 * @catigori    = category ID
 * @from        = date start
 * @to          = date end
 *
 * @per_page    = for pagination
 */

export async function Search(FORM, page = 1) {
  let per_page = 9;
  return await new Promise((resolve, reject) => {
    axios
      .post(API + "/events/search?per_page=" + per_page + "&page=" + page, FORM)
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}


export async function SearchMapViewer(params) {
  return await new Promise((resolve, reject) => {
    axios
      .get(`${API}/events/search-map-viewer?${params}`) // Append query parameters to the URL
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response ? err.response : err);
      });
  });
}


export async function Events(params = {}) {
  const {
    page = 1, // Default to page 1 if not provided
    type,
    activityName,
    city,
    miles,
    minPrice,
    maxPrice,
    eventType,
    current_event,
    per_page: per_page_override,
  } = params;

  let per_page = per_page_override || 9;
  let is_related = type === "Sejour";

  // Construct the base URL
  let baseURL = type ? `/events/type/${type}` : `/events`;

  // Initialize URLSearchParams
  let searchParams = new URLSearchParams();

  // Add parameters if they have meaningful values
  searchParams.set("per_page", per_page);
  searchParams.set("page", page);
  searchParams.set("is_related", is_related);
  if (current_event) searchParams.set("current_event", current_event);
  if (activityName) searchParams.set("activityName", activityName);
  if (city && city !== "all") searchParams.set("city", city);
  if (miles) searchParams.set("miles", miles);
  if (minPrice) searchParams.set("minPrice", minPrice);
  if (maxPrice) searchParams.set("maxPrice", maxPrice);
  if (eventType) searchParams.set("eventType", eventType);

  // Construct the full URL with query parameters
  let eventsLink = `${baseURL}?${searchParams.toString()}`;

  // Make the API call
  try {
    const response = await axios.get(`${API}${eventsLink}`); // Ensure `API` is defined or replace `API` with your actual API base URL
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : "API call failed");
  }
}


/**
 * Event
 * @id  = event ID
 */

export async function Event(id) {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/events/" + id)
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Hote events
 * @per_page    = for pagination
 */

export async function HoteEvents(page = 1, per_page = 9) {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/hot-events?per_page=" + per_page + "&page=" + page)
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Search for events
 * @event_id    = event ID
 * @depart_city = city
 * @roader      = roader > not required
 * @prices      = prices > multiple qty_{price_name}_{event_id}
 */

export async function Order(FORM) {
  // Read the token fresh from localStorage at call time. The module-level
  // AuthStorage is a snapshot taken at import; if the user logs in/registers
  // during the session (e.g. the inline confirm sheet) it would be stale.
  const auth = JSON.parse(localStorage.getItem("auth")) || {};
  return await new Promise((resolve, reject) => {
    if (Object.keys(auth).length) {
      axios
        .post(API + "/reservation", FORM, {
          headers: {
            Authorization: `Bearer ${auth.access_token}`,
          },
        })
        .then(async (res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err.response);
        });
    } else {
      reject({ errors: "Unauthorized" });
    }
  });
}

// updating Order
export async function updateOrder(FORM) {
  return await new Promise((resolve, reject) => {
    if (Object.keys(AuthStorage).length) {
      // There is some data
      axios
        .put(API + "/reservation", FORM, {
          headers: {
            Authorization: `Bearer ${AuthStorage.access_token}`,
          },
        })
        .then(async (res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err.response);
        });
    } else {
      reject({ errors: "Unauthorized" });
    }
  });
}

/**
 * Get user commandes not confirmed
 * @auth
 */
export async function UserOrdersUnconfirmed() {
  // Read fresh from localStorage rather than the module-level AuthStorage
  // snapshot — same stale-snapshot issue documented on Auth() above. Left
  // stale here, this call rejected immediately with "Unauthorized" whenever
  // the user signed in after the bundle first loaded (e.g. inline during
  // checkout), silently leaving the account page's order lists empty.
  const auth = JSON.parse(localStorage.getItem("auth")) || {};
  return await new Promise((resolve, reject) => {
    if (Object.keys(auth).length) {
      // There is some data
      axios
        .get(API + "/user/commandes", {
          headers: {
            Authorization: `Bearer ${auth.access_token}`,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    } else {
      reject({ errors: "Unauthorized" });
    }
  });
}

/**
 * Get user commandes confirmed
 * @auth
 */
export async function UserOrdersConfirmed() {
  const auth = JSON.parse(localStorage.getItem("auth")) || {};
  return await new Promise((resolve, reject) => {
    if (Object.keys(auth).length) {
      // There is some data
      axios
        .get(API + "/user/reservations", {
          headers: {
            Authorization: `Bearer ${auth.access_token}`,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    } else {
      reject({ errors: "Unauthorized" });
    }
  });
}

/**
 * Get user reviews for his orders
 *
 */

export async function UserReviews() {
  return await new Promise((resolve, reject) => {
    if (Object.keys(AuthStorage).length) {
      // There is some data
      axios
        .get(API + "/user/reviews", {
          headers: {
            Authorization: `Bearer ${AuthStorage.access_token}`,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    } else {
      reject({ errors: "Unauthorized" });
    }
  });
}

/**
 * Orders who can this user put a review
 *
 */

export async function EventsForReview() {
  return await new Promise((resolve, reject) => {
    if (Object.keys(AuthStorage).length) {
      // There is some data
      axios
        .get(API + "/user/reviews/events", {
          headers: {
            Authorization: `Bearer ${AuthStorage.access_token}`,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    } else {
      reject({ errors: "Unauthorized" });
    }
  });
}

/**
 *
 * @param {event_id,rating,comment} FORM
 */
export async function SendReview(FORM) {
  return await new Promise((resolve, reject) => {
    axios
      .post(API + "/user/review", FORM, {
        headers: {
          Authorization: `Bearer ${AuthStorage.access_token}`,
        },
      })
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 *
 * @param {event_id,rating,comment} FORM
 */
export async function CancelOrder(FORM) {
  return await new Promise((resolve, reject) => {
    axios
      .put(API + "/cancel/reservation", FORM, {
        headers: {
          Authorization: `Bearer ${AuthStorage.access_token}`,
        },
      })
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Get partner information
 */
export async function PartnerInformation(id) {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/partner/" + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}
/**
 * Get user analytics for partner
 */
export async function PartnerAnalytics() {
  return await new Promise((resolve, reject) => {
    if (Object.keys(AuthStorage).length) {
      // There is some data
      axios
        .get(API + "/partner/analytics", {
          headers: {
            Authorization: `Bearer ${AuthStorage.access_token}`,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    } else {
      reject({ errors: "Unauthorized" });
    }
  });
}

/**
 * Get user commandes not confirmed
 * @auth
 */
export async function PartnerOrders(page = 1) {
  let per_page = 10;
  return await new Promise((resolve, reject) => {
    if (Object.keys(AuthStorage).length) {
      // There is some data
      axios
        .get(
          API + "/partner/reservations?per_page=" + per_page + "&page=" + page,
          {
            headers: {
              Authorization: `Bearer ${AuthStorage.access_token}`,
            },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    } else {
      reject({ errors: "Unauthorized" });
    }
  });
}

/**
 *
 * @param {*} page
 */
export async function PartnerEvents(page = 1) {
  let per_page = 10;
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/partner/events?per_page=" + per_page + "&page=" + page, {
        headers: {
          Authorization: `Bearer ${AuthStorage.access_token}`,
        },
      })
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Event
 * @id  = event ID
 */

export async function PartnerEvent(id) {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/partner/event/" + id, {
        headers: {
          Authorization: `Bearer ${AuthStorage.access_token}`,
        },
      })
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 *
 * @param {*} page
 */
export async function PartnerReviews(page = 1) {
  let per_page = 10;
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/partner/reviews?per_page=" + per_page + "&page=" + page, {
        headers: {
          Authorization: `Bearer ${AuthStorage.access_token}`,
        },
      })
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function AllCities() {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/all-cities")
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function AllCategories() {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/all-categories")
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function AllPricesCategories() {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/categories-prices", {
        headers: {
          Authorization: `Bearer ${AuthStorage.access_token}`,
        },
      })
      .then(async (res) => {
        //console.log( res.data );
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function PriceEventUnlisted(id) {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/partner/events/pricesNotSaved/" + id, {
        headers: {
          Authorization: `Bearer ${AuthStorage.access_token}`,
        },
      })
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function AddCity(FORM) {
  return await new Promise((resolve, reject) => {
    const _header = {
      Authorization: `Bearer ${AuthStorage.access_token}`,
    };
    axios
      .post(API + "/cities/store", FORM, {
        headers: _header,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function AddCategory(FORM) {
  return await new Promise((resolve, reject) => {
    const _header = {
      Authorization: `Bearer ${AuthStorage.access_token}`,
    };
    axios
      .post(API + "/categories/store", FORM, {
        headers: _header,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function AddEvent(FORM, myHeader = {}) {
  return await new Promise((resolve, reject) => {
    const _header = {
      Authorization: `Bearer ${AuthStorage.access_token}`,
    };
    const _headerAssign = Object.assign(_header, myHeader);
    axios
      .post(API + "/partner/events/store", FORM, {
        headers: _headerAssign,
      })
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function UpdateEvent(id, FORM, myHeader = {}) {
  return await new Promise((resolve, reject) => {
    const _header = {
      Authorization: `Bearer ${AuthStorage.access_token}`,
    };
    const _headerAssign = Object.assign(_header, myHeader);
    axios
      .post(API + "/partner/events/update/" + id, FORM, {
        headers: _headerAssign,
      })
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function DeleteEvent(id) {
  return await new Promise((resolve, reject) => {
    const _header = {
      Authorization: `Bearer ${AuthStorage.access_token}`,
    };
    axios
      .delete(API + "/partner/events/delete/" + id, {
        headers: _header,
      })
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 *
 * @param {*} page
 */
export async function PartnerPrices(page = 1) {
  let per_page = 10;
  return await new Promise((resolve, reject) => {
    axios
      .get(
        API + "/partner/fixed-prices?per_page=" + per_page + "&page=" + page,
        {
          headers: {
            Authorization: `Bearer ${AuthStorage.access_token}`,
          },
        }
      )
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 * Event
 * @id  = event ID
 */

export async function PartnerPrice(id) {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/partner/fixed-prices/" + id, {
        headers: {
          Authorization: `Bearer ${AuthStorage.access_token}`,
        },
      })
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function AddPrice(FORM, myHeader = {}) {
  return await new Promise((resolve, reject) => {
    const _header = {
      Authorization: `Bearer ${AuthStorage.access_token}`,
    };
    const _headerAssign = Object.assign(_header, myHeader);
    axios
      .post(API + "/partner/fixed-prices", FORM, {
        headers: _headerAssign,
      })
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function UpdatePrice(id, FORM, myHeader = {}) {
  return await new Promise((resolve, reject) => {
    const _header = {
      Authorization: `Bearer ${AuthStorage.access_token}`,
    };
    const _headerAssign = Object.assign(_header, myHeader);
    axios
      .post(API + "/partner/fixed-prices/update/" + id, FORM, {
        headers: _headerAssign,
      })
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function DeletePrice(id) {
  return await new Promise((resolve, reject) => {
    const _header = {
      Authorization: `Bearer ${AuthStorage.access_token}`,
    };
    axios
      .delete(API + "/partner/fixed-prices/" + id, {
        headers: _header,
      })
      .then(async (res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export async function CheckCoupon(FORM) {
  return await new Promise((resolve, reject) => {
    axios
      .post(API + "/verify/coupon", FORM)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

/**
 *
 * @param {full_name , email, phone, number_people, message} FORM
 * @returns
 */
export async function Contact(FORM) {
  return await new Promise((resolve, reject) => {
    axios
      .post(API + "/contacts", FORM)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

// prepare payament
export async function preparePayment(reservationId) {
  // Read auth fresh from localStorage rather than the module-level
  // AuthStorage snapshot — that constant is captured once when the JS
  // bundle first parses, so it stays empty for the rest of the SPA session
  // if the user authenticates later (e.g. inline during checkout, right
  // before landing on the page that renders the "Pay now" button). Using
  // the stale snapshot here made preparePayment silently reject with
  // "Unauthorized" and made the Pay now button appear to do nothing.
  const auth = JSON.parse(localStorage.getItem("auth")) || {};
  return await new Promise((resolve, reject) => {
    if (Object.keys(auth).length) {
      // There is some data
      axios
        .get(API + "/preparePayment/" + reservationId, {
          headers: {
            Authorization: `Bearer ${auth.access_token}`,
          },
        })
        .then(async (res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err.response);
        });
    } else {
      reject({ errors: "Unauthorized" });
    }
  });
}

export async function TransactionDetail(reservationId) {
  // Same stale-module-snapshot issue as preparePayment() above — read fresh.
  const auth = JSON.parse(localStorage.getItem("auth")) || {};
  return await new Promise((resolve, reject) => {
    if (Object.keys(auth).length) {
      // There is some data
      axios
        .get(API + "/getTransactionDetail/" + reservationId, {
          headers: {
            Authorization: `Bearer ${auth.access_token}`,
          },
        })
        .then(async (res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err.response);
        });
    } else {
      reject({ errors: "Unauthorized" });
    }
  });
}

export function downloadBarcodeImage(imageUrl) {
  if (!Object.keys(AuthStorage).length) {
    return Promise.reject({ errors: "Unauthorized" });
  }

  return axios
   .post(API + "/download-ticket", {
    image_url : imageUrl
  }, {
    headers: {
      Authorization: `Bearer ${AuthStorage.access_token}`,
      "Content-Type": "application/json",
      Accept: "application/octet-stream",
    },
    responseType: "blob",
  });
}

// Download the PDF invoice for a reservation — only ever succeeds once the
// reservation was actually paid online (payment_history.status === 'CHARGED'),
// the backend 404s otherwise. Reads auth fresh from localStorage rather than
// the module-level AuthStorage snapshot, since that constant is captured
// once at bundle load and stays stale/empty if the user authenticated later
// in the same session (see preparePayment/TransactionDetail above for the
// same fix).
export function downloadInvoice(reservationId) {
  const auth = JSON.parse(localStorage.getItem("auth")) || {};
  if (!Object.keys(auth).length) {
    return Promise.reject({ errors: "Unauthorized" });
  }

  return axios.get(`${API}/reservation/${reservationId}/invoice`, {
    headers: {
      Authorization: `Bearer ${auth.access_token}`,
      Accept: "application/pdf",
    },
    responseType: "blob",
  });
}


export async function searchActivities(activityName) {
  return await new Promise((resolve, reject) => {
    axios
      .get(API + "/search-activities/" + activityName)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
}

export function formatDateTime(dateTimeString) {
  const options = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" };
  const formattedDateTime = new Date(dateTimeString).toLocaleString("en-US", options);
  return formattedDateTime;
}

export function formatDate(date) {
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  const formattedDate = new Date(date).toLocaleString("en-US", options);
  return formattedDate;
}
